/**
 * ラリーのスポットを地図から選ぶピッカー
 *
 * ラリーごとに色を変えて、未獲得は薄く塗る。「今日この辺で回れる残り」を掴むのが目的。
 * 選択状態は呼び出し側が持つので、選んだ場所をルート作成にもプランへの追加にも使える。
 */

import { type ReactNode, useState } from 'react'

import type { StampRallySummary } from '@/api/types/stamp-rally'

import { RallyMapPanel } from './rally-map-panel'
import type { RallyPlaceGroup } from './rally-place-popup'
import { useRallyPlaces } from './use-rally-places'

export type { RallyPlaceGroup } from './rally-place-popup'

type Props = {
  /** 凡例と色に使う */
  rallies: StampRallySummary[]
  selectedPlaceIds: number[]
  onToggle: (place: RallyPlaceGroup) => void
  onClear: () => void
  /** 渡すと絞り込みに合う場所をまとめて選べる */
  onSelectAll?: (places: RallyPlaceGroup[]) => void
  /** 地図に出さない場所。すでにプランへ入っているスポットなど */
  excludePlaceIds?: number[]
  /** いま編集しているプラン。自分自身は「他のプランに追加済み」に数えない */
  currentPlanId?: number | null
  /** 選択中に地図の下部へ「解除」と並べて重ねる実行ボタン */
  footer?: ReactNode
}

export const RallyMapPicker = ({
  rallies,
  selectedPlaceIds,
  onToggle,
  onClear,
  onSelectAll,
  excludePlaceIds,
  currentPlanId = null,
  footer,
}: Props) => {
  const [activePlaceId, setActivePlaceId] = useState<number | null>(null)
  const rallyPlaces = useRallyPlaces({ rallies, excludePlaceIds, keepPlaceId: activePlaceId, currentPlanId })

  return (
    <RallyMapPanel
      rallyPlaces={rallyPlaces}
      activePlaceId={activePlaceId}
      onActivate={setActivePlaceId}
      selectedPlaceIds={selectedPlaceIds}
      onToggle={onToggle}
      onClear={onClear}
      onSelectAll={onSelectAll}
      footer={footer}
    />
  )
}
